// extracted by mini-css-extract-plugin
module.exports = {"helperText":"HelperText_helperText__1L5FS"};